import { render, staticRenderFns } from "./editData.vue?vue&type=template&id=1fa17502&scoped=true&"
import script from "./editData.vue?vue&type=script&lang=js&"
export * from "./editData.vue?vue&type=script&lang=js&"
import style0 from "./editData.vue?vue&type=style&index=0&id=1fa17502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa17502",
  null
  
)

export default component.exports